import { PropTypes } from "react";
import { httpPost } from "../../../modules/ajax/ajax_helper";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import NonsocialUpdate from "../nonsocial_update";
import ExpandableHtml from "../../user_content/expandable_html";
import NewsfeedItemHeaderTimestamp from "../newsfeed_item_header_timestamp";

export default GrComponentFactory.createClass({
  displayName: "CustomNewsfeedItem",

  propTypes: {
    resource: PropTypes.shape({
      updateIconUrl: PropTypes.string.isRequired,
      headline: PropTypes.string.isRequired,
      headlineUrl: PropTypes.string,
      title: PropTypes.string,
      titleUrl: PropTypes.string,
      description: PropTypes.shape(GrPropTypes.expandableHtml()),
      imageUrl: PropTypes.string,
      cta: PropTypes.string,
      ctaUrl: PropTypes.string,
    }).isRequired,
  },

  renderLinkOrText(key) {
    const section = this.props.resource[key];
    const url = this.props.resource[`${key}Url`];
    return url ?
      <a href={url}
         onClick={() => this.handleClick(key)}
         className="gr-hyperlink gr-hyperlink--bold">
      {section}
      </a> :
      <span>{section}</span>;
  },

  renderHeader() {
    return(
      <div>
        {this.renderLinkOrText("headline")}
        <NewsfeedItemHeaderTimestamp time={this.props.updatedAt} />
      </div>
    );
  },

  handleClick(key) {
    httpPost("/track/track_click", {
      data: { feature: `CustomNewsfeedDesktop_${key}` },
    });
    return true;
  },

  renderBody() {
    const resource = this.props.resource;
    return(
      <div>
        <div className="customNewsfeedCard">
          {resource.title &&
            <div className="customNewsfeedCard__title">
              {this.renderLinkOrText("title")}
            </div>
          }

          {resource.imageUrl &&
            <div>
              <img className="customNewsfeedCard__image"
                   src={resource.imageUrl}
                   alt={resource.headline} />
            </div>
          }

          {resource.description &&
            <div>
              <ExpandableHtml {...this.props.resource.description} />
            </div>
          }
        </div>

        {resource.cta &&
          <div className="customNewsfeedCtaLink">
            <a onClick={() => this.handleClick("cta")} href={resource.ctaUrl}>
              {resource.cta}
            </a>
          </div>
        }
      </div>
    );
  },

  render() {
    return(
      <div>
        <NonsocialUpdate
          updateIconUrl={this.props.resource.updateIconUrl}
          header={this.renderHeader()}
          body={this.renderBody()}
        />
      </div>
    );
  },
});
